import { start } from "./samples/10-environmentmap";
start();
